import mutations from './mutations';
import getters from './getters';
import actions from './actions';
export default {
  namespaced: true,
  state() {
    return {
      academyUrl: 'https://www.zimmerpeacocktech.com/knowledge-base/djuli/djuli-learning-centre',
      companyUrl:'https://www.zimmerpeacocktech.com/',
      facebookUrl:'https://www.facebook.com/zimmerpeacock/',
      instagramUrl:'https://www.instagram.com/zimmerpeacock_ltd/?hl=en',
      linkedinUrl:'https://www.linkedin.com/company/zimmer-and-peacock-ltd/mycompany/',
      twitterUrl:'https://twitter.com/zimmerpeacock',
      mapUrl:' https://goo.gl/maps/F5WVSPMb1C8FAH8E6',
      cookiesAccepted: true,
      viewsinglereport: false,
      activeSelectedStudy:null
    };
  },
  mutations,
  actions,
  getters,
};
